import TeamInviteForm from "./team-invite-form";

export default TeamInviteForm;